import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DumpsterFire} from "../../DumpsterFire";
import {TimelineMax} from "gsap";
import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {DumpsterFireSound} from "../../sound/DumpsterFireSound";
import {DumpsterFireSymbol} from "../../reels/DumpsterFireSymbol";

export class DumpsterFireIdleNormalPresentation implements FlowStatePresentation {
    private _tl: TimelineMax | undefined;

    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        this._tl = new TimelineMax({
            delay: 0.1,
            onComplete: () => {
                flowStateController.finish();
            }
        });
        const isFreespinOrExtraSpin = DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1 || DumpsterFire.model.data.mode.indexOf("EXTRA_SPIN") > -1;
        const {mode, nextMode, upgradedSymbols} = DumpsterFire.model.data,
            isFreesSpinESToNormal: boolean = mode.indexOf("FREESPIN") > -1 && nextMode === DumpsterFireGameMode.NORMAL && upgradedSymbols.length > 0,
            isExtraSpinToNormal: boolean = mode === DumpsterFireGameMode.EXTRA_SPIN && nextMode === DumpsterFireGameMode.NORMAL;
        DumpsterFire.backgroundElements.setIdleTimeline();
        DumpsterFireSound.CLICK_YES_ARRAY = ["extraSpinYes1", "extraSpinYes2", "extraSpinYes3"];
        if (isFreespinOrExtraSpin) {
            this._tl.add(() => {
                if (!isExtraSpinToNormal && upgradedSymbols.length === 0) {
                    DumpsterFire.backgroundElements.setMode(DumpsterFireGameMode.NORMAL);
                    DumpsterFire.gameLogo.setMode(DumpsterFireGameMode.NORMAL);
                }
                DumpsterFire.model.isFreespin = false;
                DumpsterFire.winView.playNormalAnimationForAll();
            }, 0);
            if (isFreesSpinESToNormal) {
                this._tl.add(DumpsterFire.transitionView.playTransitionAnim(), 0)
                this._tl.add(() => {
                    DumpsterFire.backgroundElements.setMode(DumpsterFireGameMode.NORMAL);
                    DumpsterFire.gameLogo.setMode(DumpsterFireGameMode.NORMAL);
                }, '<0.5');
            }
        }
        DumpsterFire.keypadPlugin.setZeroBetSpinCounter(-1);
        DumpsterFire.buyFeatureName = "";
        DumpsterFire.model.resetPrevPosMulti();
        DumpsterFire.model.isMaxMulti = [];
        this._tl.add(DumpsterFire.reelAnticipation.reset(false));
        DumpsterFire.model.scatterCount = 0;
        DumpsterFire.model.scatterSymArray = [];
    }

    private skip(flowStateController: FlowStateController): void {
        if (this._tl != undefined) {
            this._tl.kill();
            delete this._tl;
            flowStateController.finish();
        }
    }
}